<template>
    <div class="search-report">
        <ais-instant-search :search-client="searchClient" index-name="dev_KAIGO">
            <v-row justify="center" class="mt-5">
                <v-col cols="8">
                    <ais-search-box>
                        <v-text-field
                        solo
                        slot-scope="{ currentRefinement, refine }"
                        label="Search for history reports"
                        placeholder=""
                        prepend-inner-icon="search"
                        :value="currentRefinement"
                        @input="refine($event)"
                        />
                    </ais-search-box>
                </v-col>
            </v-row>
            <!-- refinement list -->
            <!-- <v-row>n
                <v-list dense>
                    <ais-refinement-list attribute="pickUpTime" searchable show-more>
                        <div
                            slot-scope="{
                            items,
                            isShowingMore,
                            isFromSearch,
                            canToggleShowMore,
                            refine,
                            createURL,
                            toggleShowMore,
                            searchForItems
                            }"
                        > 
                            <v-text-field
                                type="search"
                                placeholder="Search"
                                @input="searchForItems($event)"
                                prepend-inner-icon=""
                            />
                            <v-list dense class="">
                                <span v-if="isFromSearch && !items.length" style="color:red">Results are not found..</span>
                                <v-list dense v-for="item in items" :key="item.value">
                                    <v-chip
                                        label
                                        color="info lighten-4 info--text"
                                        :href="createURL(item)"
                                        :style="{ backgroundColor: item.isRefined ?  '#ffee00' : '' }"
                                        @click.prevent="refine(item.value)"
                                        class="ma-0"
                                    >
                                        <v-avatar
                                            left
                                            color="#ffee00"
                                        >
                                            E
                                        </v-avatar>
                                        <ais-highlight attribute="item" :hit="item"/>
                                        ({{ item.count.toLocaleString() }})
                                    </v-chip>
                                </v-list>
                            </v-list>
                            <button
                                @click="toggleShowMore"
                                :disabled="!canToggleShowMore"
                            >{{ !isShowingMore ? 'Show more' : 'Show less'}}</button>
                        </div>
                    </ais-refinement-list>
                </v-list>
            </v-row> -->
            <v-row>
                <v-col>
                    <ais-hits>
                        <div slot="item" slot-scope="{ item }">
                            <v-row class="" justify="center">
                                <v-col cols="10">
                                    <v-card
                                        class="mx-auto"
                                    >
                                        <v-card-title>
                                        {{item.subject}}
                                        </v-card-title>
                    
                                        <span class="ml-5">
                                        {{item.id}} 
                                        </span>

                                        <a class="ml-5">
                                        {{item.report_link}} 
                                        </a>

                                        <v-card-subtitle>
                                            <v-container>
                                                <v-row>
                                                    <v-col>
                                                    {{item.description}}
                                                    </v-col>
                                                </v-row>
                                            </v-container>
                                        </v-card-subtitle>

                                        <v-card-actions>

                                        <v-btn
                                            icon
                                            @click="show = !show"
                                        >
                                            <v-icon>{{ show ? 'mdi-chevron-up' : 'mdi-chevron-down' }}</v-icon>
                                        </v-btn>
                                        </v-card-actions>

                                        <v-expand-transition>
                                            <div v-show="show">
                                                <v-divider></v-divider>
                                                <v-container>
                                                    <v-card-text v-html="item.report_comment">
                                                </v-card-text>
                                                </v-container>
                                            </div>
                                        </v-expand-transition>
                                    </v-card>
                                </v-col>
                            </v-row>
                        </div>
                        <!-- <div slot-scope="{items}">
                            <li v-for="item in items" :key="item.objectID">
                                {{ item.description }}
                            </li>
                            <v-btn @click="saveList(items)">Export</v-btn>
                        </div> -->
                    </ais-hits>
                </v-col>
            </v-row>
        </ais-instant-search>
    </div>
</template>

<script>
/* eslint-disable no-console */
import algoliasearch from 'algoliasearch/lite';
import 'instantsearch.css/themes/reset-min.css';
import algoliaConfig from '@/algoliaconfig'
import Cookies from 'js-cookie'

export default {
    name: 'SearchReport',
    data () {
        return {
            searchClient: algoliasearch(
                algoliaConfig.api_key,
                algoliaConfig.password,
            ),
            show:false,
            searchResults:[]
        }
    },
    created(){
        Cookies.set('name', 'value', { samesite: 'Secure' })
    }
    // methods:{
    //     saveList(items){
    //         console.log(items)
    //     }
    // },
}
</script>

<style>
.ais-SearchBox-input {
    border: 2px solid #ffee00;
    border-radius: 4px;
    min-width: 400px;
}
</style>